import { ExMutationTree } from "vuex";
import { State, Mutations } from "./types";
import { sortPlans } from "@/helpers/plans-helper";

const mutations: ExMutationTree<State, Mutations> = {
  getPlansSuccess(state, payload) {
    state.plans = payload.plans;
  },
  createPlanSuccess(state, payload) {
    if (!state.plans) return;
    state.plans = sortPlans([...state.plans, payload.plans]);
  },
  updatePlanSuccess(state, payload) {
    if (!state.plans) return;
    const newPlans = state.plans.map(plan =>
      plan.id === payload.plans.id ? payload.plans : plan
    );
    state.plans = newPlans;
  },
  deletePlanSuccess(state, payload) {
    state.plans = state.plans.filter(plan => {
      return plan.id !== payload.planId;
    });
  }
};

export default mutations;
